'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _throughContainer = require('./throughContainer');

var _throughContainer2 = _interopRequireDefault(_throughContainer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var throughArea = function throughArea(areaName) {
  return function (Component) {
    return (0, _throughContainer2.default)(areaName)(function (_ref) {
      var area = _ref[areaName],
          rest = _objectWithoutProperties(_ref, [areaName]);

      return _react2.default.createElement(Component, _extends({}, rest, area));
    });
  };
};

exports.default = throughArea;